import { useCallback } from 'react';
import { useTracking } from '@edreamsodigeo/frontend-core';

export const TRACKING = {
  ACTION: 'prime_hotel-banner',
  LABEL: {
    LOAD: 'prime_hotel-banner_onload_pag:flsum_RD:0',
    VISIBLE: 'prime_hotel-banner_visible_pag:flsum',
    CLICK_CHECK: 'prime_hotel-banner_click_check_pag:flsum',
    CLICK_UNCHECK: 'prime_hotel-banner_click_uncheck_pag:flsum',
  },
};

export const useHotelDealsMobileCardTracking = () => {
  const { trackEvent } = useTracking();

  const trackLoad = useCallback(() => {
    trackEvent({
      action: TRACKING.ACTION,
      label: TRACKING.LABEL.LOAD,
    });
  }, [trackEvent]);

  const trackVisible = useCallback(() => {
    trackEvent({
      action: TRACKING.ACTION,
      label: TRACKING.LABEL.VISIBLE,
    });
  }, [trackEvent]);

  const trackCheckboxClick = (isChecked) => {
    trackEvent({
      action: TRACKING.ACTION,
      label: isChecked
        ? TRACKING.LABEL.CLICK_CHECK
        : TRACKING.LABEL.CLICK_UNCHECK,
    });
  };

  return {
    trackLoad,
    trackVisible,
    trackCheckboxClick,
  };
};
